import React from "react";
import { Link } from "react-router-dom";
import { Accessibility, ArrowRight, MapPin, Users } from "lucide-react";

export default function SpaceCard({ space, detailed = false }) {
  const image = space.images?.[0];
  const imageUrl = image?.url || (typeof image === "string" && image.startsWith("http") ? image : "");
  const imageAlt = image?.alt || space.name;
  return (
    <article className="phx-space-card">
      {imageUrl ? <div className="phx-space-image"><img src={imageUrl} alt={imageAlt} /></div> : null}
      <div className="phx-space-body">
        <div className="phx-space-heading">
          <div>
            <p className="phx-kicker">{space.location}</p>
            <h3>{space.name}</h3>
          </div>
          <strong className="phx-rate">{space.rateLabel}</strong>
        </div>
        <p>{space.description}</p>
        <div className="phx-meta-row">
          <span><MapPin aria-hidden="true" /> {space.location}</span>
          {space.capacity ? <span><Users aria-hidden="true" /> Up to {space.capacity}</span> : null}
        </div>
        <div>
          <h4>Suitable for</h4>
          <ul className="phx-chip-list">
            {(space.suitableActivities || []).map((activity) => <li key={activity}>{activity}</li>)}
          </ul>
        </div>
        {detailed ? (
          <div className="phx-space-details">
            <div>
              <h4>Facilities</h4>
              <ul>{(space.facilities || []).map((facility) => <li key={facility}>{facility}</li>)}</ul>
            </div>
            <div>
              <h4><Accessibility aria-hidden="true" /> Accessibility</h4>
              <p>{space.accessibility || "Tell UUN about any access requirements when enquiring."}</p>
            </div>
          </div>
        ) : null}
        <Link className="phx-button phx-button-secondary" to={`/phoenix-hub/book?space=${space.id}`}>
          Request this space <ArrowRight aria-hidden="true" />
        </Link>
      </div>
    </article>
  );
}
